// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"49e47b17","64":"db52de36","419":"faa57d20","563":"877fb005","785":"aa48ccd9","787":"82de9e9b","942":"4356cc5c"}[chunkId] + ".chunk.js";
};